import React from 'react';
import { LoadingComponentProps } from 'react-loadable';
import { Box, CircularProgress, Typography, makeStyles } from '@material-ui/core';

interface IProps extends LoadingComponentProps {}

const useStyles = makeStyles({
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    zIndex: 1000,
  },
});

const LoadableLoading: React.ComponentType<IProps> = ({ error }) => {
  // Styles
  const classes = useStyles();

  if (error) {
    const { response } = error;

    if (response && response.status === 404) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 5 }}>
          <Typography component="h1" variant="h4">
            404 Error
          </Typography>

          <Typography>Ooops page not found!</Typography>
        </Box>
      );
    }
  }

  return (
    <Box className={classes.loader}>
      <CircularProgress />
    </Box>
  );
};

export default LoadableLoading;
